export function getTokenExpDuration(authObj) {
    return new Date(authObj.exp * 1000).getTime() - new Date().getTime();
}